// Burger menu
const burgerButton = document.querySelector('[data-ident="burger"]')
const nav = document.querySelector('#nav')

burgerButton.addEventListener('click', (e) => {
  const attrExpanded = burgerButton.getAttribute('aria-expanded')
  nav.classList.toggle('visible')
  burgerButton.setAttribute(
    'aria-expanded',
    attrExpanded === 'true' ? 'false' : 'true'
  )
})
